import moment from "moment";
class Controller {
  constructor(
    $injector,
    Sections,
    $stateParams,
    HolidayTransforms,
    HolidaysTransforms,
    $filter
  ) {
    "ngInject";

    this.Events = $injector.get("Events");
    this.Holiday = $injector.get("Holiday");
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.sections = Sections.settingsSections;
    this.HolidayTransforms = HolidayTransforms;

    this.onUpdate = this.Events.getUpdateEvent("holiday");
  }
  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (item) => {
      const updatedItem = {};
      updatedItem[item.key] =
        typeof item.value !== "undefined"
          ? item.value
          : item.name
          ? item.name._id
          : null;
      updatedItem[item.key] =
        item.key === "date"
          ? moment(updatedItem[item.key]).format("YYYY-MM-DD")
          : item.value;
      this.Holiday[item.method](
        this.$stateParams.id,
        item.methodName,
        updatedItem
      ).$promise.then(() => {
        this.holiday[item.key].isDisabled = true;
        this.Events.emit(showNotificationEvent, {
          message: `Your holiday "${item.key}" has been updated successfully`,
        });
      });
    };

    this.Holiday.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.holiday = this.HolidayTransforms.justify(response);
      },
      (response) => this.Events.emit(errorEvent, response.data)
    );

    this.Events.on(this.onUpdate, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/holiday/holiday.controller.js